<template>
  <div class="page-content free-study-page">
    <div class="content-wrap" v-loading="pageLoading">
        <div class="mianbao mt2">
          <span class="dq">当前位置：</span>
          <a href="javascript:void(0);" @click="$router.push('/main/home')" class="mba">个人中心</a> &gt;
          <a href="javascript:void(0);" @click="$router.push('/main/specialtyPlan')" class="mba">专业计划</a> &gt;
          <a href="javascript:void(0);" @click="$router.back()" class="mba">自由学习</a> &gt;
          <span class="site">题库练习</span>
        </div>

        <div class="paper-header">
          <div>
            <p class="paper-title">{{ paperInfo.name }}</p>
            <div class="paper-meta">
              <span>课程：{{ paperInfo.courseFullName }}</span>
              <span>题量：{{ totalCount }}题</span>
            </div>
          </div>
          <div class="mode-badge">
            <span class="dot"></span>
            <span>{{ mode === 'answer' ? '答题模式' : '背题模式' }}</span>
          </div>
        </div>

        <div class="toolbar">
          <div class="left">
            <div class="view-switch">
              <div class="view-btn" :class="{ active: viewMode === 'full' }" @click="switchViewMode('full')">整卷模式</div>
              <div class="view-btn" :class="{ active: viewMode === 'single' }" @click="switchViewMode('single')">单题模式</div>
            </div>
          </div>
          <div class="right">
            <span v-if="mode === 'back'" class="answer-progress">已背 {{ reviewedCount }}/{{ totalCount }} 题</span>
            <span v-else class="answer-progress">已答 {{ answeredCount }}/{{ totalCount }} 题</span>
          </div>
        </div>

        <div class="question-area" :class="{ 'back-mode': mode === 'back' }">
          <div class="question-main">
            <div v-for="(section, si) in sections" :key="si" class="question-card" v-show="viewMode === 'full' || isSectionActive(si)">
              <div class="q-section-title" v-show="viewMode === 'full' || isSectionActive(si)">{{ sectionTitle(section, si) }}</div>
              <div
                v-for="(q, qi) in section.questions"
                :key="q.id"
                class="q-item"
                :ref="'qItem_' + flatIndex(si, qi)"
                v-show="viewMode === 'full' || flatIndex(si, qi) === singleIndex"
              >
                <div class="q-num">
                  {{ q.globalIndex }}. 
                  <div class="questionTxt">
                    <span v-html="q.content || q.title"></span>
                  </div>
                  <span
                    class="fav-btn"
                    :class="{ active: q.isFav }"
                    @click="toggleFav(q)"
                  >
                    <span class="fav-icon"></span>{{ q.isFav ? '已收藏' : '收藏' }}
                  </span>
                </div>
                <template v-if="q.type === 'SINGLECHOICE' || q.type === 'MULTIPLECHOICE' || q.type === 'JUDGMENT'">
                  <ul class="q-options">
                    <template v-if="q.type === 'JUDGMENT'">
                      <li
                        :class="getOptionClass(q, 'Y')"
                        @click="selectOption(q, 'Y')"
                      >
                        <span class="radio"></span>A. 正确
                      </li>
                      <li
                        :class="getOptionClass(q, 'N')"
                        @click="selectOption(q, 'N')"
                      >
                        <span class="radio"></span>B. 错误
                      </li>
                    </template>
                    <template v-else>
                      <li
                        v-for="(opt, oi) in q.options"
                        :key="oi"
                        :class="getOptionClass(q, opt.alisa)"
                        @click="selectOption(q, opt.alisa)"
                      >
                        <span class="radio"></span>{{ opt.alisa }}. <span v-html="opt.text"></span>
                      </li>
                    </template>
                  </ul>
                  <span
                    v-if="mode === 'answer'"
                    class="analysis-btn"
                    @click="q.showAnalysis = !q.showAnalysis"
                  >{{ q.showAnalysis ? '收起解析' : '查看解析' }}</span>
                  <div class="analysis-box" v-if="q.showAnalysis || mode === 'back'">
                    <p class="label">解析</p>
                    <p class="answer">
                      正确答案：{{ q.type === 'JUDGMENT' ? (q.answer === 'Y' ? '正确' : '错误') : q.answer }}
                      <template v-if="isChoiceAnswerWrong(q)">
                        &nbsp; 你的答案：{{ q.type === 'JUDGMENT' ? (q.myAnswer === 'Y' ? '正确' : '错误') : (Array.isArray(q.myAnswer) ? q.myAnswer.join('') : q.myAnswer) }} ✗
                      </template>
                    </p>
                    <p class="detail" v-if="q.analysis || q.ext"><span v-html="q.analysis || q.ext"></span></p>
                  </div>
                </template>
                <template v-else-if="q.type === 'BLANKFILL'">
                  <div class="blank-inputs" v-if="mode === 'answer'">
                    <input
                      v-for="(item, bi) in q.myAnswer"
                      :key="bi"
                      v-model="q.myAnswer[bi]"
                      class="blank-input"
                      placeholder="请输入"
                      @input="onBlankInput(q)"
                    />
                  </div>
                  <span
                    v-if="mode === 'answer'"
                    class="analysis-btn"
                    @click="q.showAnalysis = !q.showAnalysis"
                  >{{ q.showAnalysis ? '收起解析' : '查看解析' }}</span>
                  <div class="analysis-box" v-if="q.showAnalysis || mode === 'back'">
                    <p class="label">参考答案</p>
                    <p class="detail" v-for="(b, bi) in (q.blanks || [])" :key="bi">第{{ bi + 1 }}空：{{ b.value }}</p>
                    <p class="detail" v-if="q.analysis || q.ext"><span v-html="q.analysis || q.ext"></span></p>
                  </div>
                </template>
                <template v-else>
                  <textarea
                    v-if="mode === 'answer'"
                    class="subjective-area"
                    v-model="q.myAnswer"
                    placeholder="请输入你的答案..."
                    @input="onSubjectiveInput(q)"
                  ></textarea>
                  <span
                    v-if="mode === 'answer'"
                    class="analysis-btn"
                    @click="q.showAnalysis = !q.showAnalysis"
                  >{{ q.showAnalysis ? '收起解析' : '查看解析' }}</span>
                  <div class="analysis-box" v-if="q.showAnalysis || mode === 'back'">
                    <p class="label">参考答案</p>
                    <p class="detail"><span v-html="q.answer || q.key || q.analysis"></span></p>
                  </div>
                </template>
              </div>
            </div>

            <div class="single-nav" v-if="viewMode === 'single'">
              <button class="nav-btn" :disabled="singleIndex === 0" @click="singleIndex--">上一题</button>
              <span class="progress">第 <b>{{ singleIndex + 1 }}</b> / <b>{{ totalCount }}</b> 题</span>
              <button class="nav-btn primary" :disabled="singleIndex >= totalCount - 1" @click="singleIndex++">下一题</button>
            </div>
          </div>

          <div class="answer-sheet">
            <div class="sheet-card" :style="{ top: sheetCardTop + 'px' }">
              <p class="sheet-title">答题卡</p>
              <div class="sheet-legend">
                <span><span class="dot c3"></span> 当前</span>
                <span v-if="mode !== 'back'"><span class="dot c1"></span> 已答</span>
                <span v-if="mode !== 'back'"><span class="dot c2"></span> 未答</span>
                <span v-if="mode === 'back'"><span class="dot c1"></span> 已背</span>
                <span v-if="mode === 'back'"><span class="dot c2"></span> 未背</span>
              </div>
              <div class="sheet-grid">
                <span
                  v-for="(q, idx) in flatQuestions"
                  :key="idx"
                  class="num"
                  :class="{
                    current: idx === singleIndex,
                    done: q.answered || (mode === 'back' && reviewedIds.includes(idx))
                  }"
                  @click="goQuestion(idx)"
                >{{ idx + 1 }}</span>
              </div>
              <button v-if="mode !== 'back'" class="submit-btn" @click="handleSubmit">提交</button>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { quesMap, sectionTitle as _sectionTitle } from "@/utils/enums";

export default {
  name: "freeStudyPaper",
  components: {},
  data() {
    return {
      recordId:'',
      paperId: '',
      courseId: '',
      mode: 'answer',
      viewMode: 'full',
      singleIndex: 0,
      paperInfo: {},
      sections: [],
      quesMap,
      sheetCardTop: 343,
      pageLoading: false,
      reviewedIds: [],
    };
  },
  watch: {
    singleIndex(val) {
      if (this.mode === 'back' && !this.reviewedIds.includes(val)) {
        this.reviewedIds.push(val);
      }
    },
  },
  computed: {
    flatQuestions() {
      const list = [];
      this.sections.forEach(s => { s.questions.forEach(q => list.push(q)); });
      return list;
    },
    totalCount() { return this.flatQuestions.length; },
    answeredCount() { return this.flatQuestions.filter(q => q.answered).length; },
    reviewedCount() { return this.reviewedIds.length; },
  },
  created() {
    this.paperId = this.$route.query.paperId;
    this.courseId = this.$route.query.courseId;
    this.mode = this.$route.query.mode || 'answer';
    if (!this.paperId || !this.courseId) {
      this.$message.warning('参数缺失，即将返回');
      this.$router.replace('/main/specialtyPlan');
      return;
    }
    this.getPaperData();
  },
  mounted() {
    this._onScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.sheetCardTop = scrollTop > 300 ? 160 : 343;
      if (this.viewMode === 'full' && this.flatQuestions.length > 0) {
        const viewportCenter = scrollTop + window.innerHeight / 2;
        let closestIdx = 0;
        let closestDist = Infinity;
        for (let i = 0; i < this.flatQuestions.length; i++) {
          const ref = this.$refs['qItem_' + i];
          const el = ref && (Array.isArray(ref) ? ref[0] : ref);
          if (el) {
            const rect = el.getBoundingClientRect();
            const elCenter = scrollTop + rect.top + rect.height / 2;
            const dist = Math.abs(elCenter - viewportCenter);
            if (dist < closestDist) {
              closestDist = dist;
              closestIdx = i;
            }
          }
        }
        this.singleIndex = closestIdx;
      }
    };
    window.addEventListener('scroll', this._onScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._onScroll, true);
  },
  methods: {
    switchViewMode(mode) {
      if (this.viewMode === mode) return;
      const currentIdx = this.singleIndex;
      this.viewMode = mode;
      if (mode === 'full') {
        this.$nextTick(() => {
          const ref = this.$refs['qItem_' + currentIdx];
          const el = ref && (Array.isArray(ref) ? ref[0] : ref);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    },
    getPaperData() {
      this.pageLoading = true;
      const req =
        this.mode === 'answer'
          ? this.$http.post('/student/pc/freeStudy/startOrContinue', {
              paperId: this.paperId,
              courseId: this.courseId,
            })
          : this.$http.get('/student/pc/freeStudy/paperDetail', {
              paperId: this.paperId,
              courseId: this.courseId,
            });
      req
        .then(res => {
          this.recordId = res.recordId || '';
          this.paperInfo = res.paperInfo || {};
          const sections = res.sections || [];
          let globalIndex = 0;
          sections.forEach(section => {
            section.questions = (section.questions || []).map(q => {
              globalIndex++;
              const qType = typeof q.type === 'string' ? q.type : '';
              const isChoice =
                qType === 'SINGLECHOICE' || qType === 'MULTIPLECHOICE' || qType === 'JUDGMENT';
              const isBlank = qType === 'BLANKFILL';
              let content = q.content || q.title || '';
              if (isBlank) {
                content = content.replace(/\[BlankArea\d+\]/g, '______');
              }
              let myAnswer = '';
              if (isChoice) {
                myAnswer =
                  qType === 'MULTIPLECHOICE' ? q.myAnswer || [] : q.myAnswer != null ? q.myAnswer : '';
              } else if (isBlank) {
                myAnswer = q.myAnswer || (q.blanks ? q.blanks.map(() => '') : ['']);
              } else {
                myAnswer = q.myAnswer != null ? q.myAnswer : '';
              }
              return {
                ...q,
                type: qType || q.type,
                content,
                globalIndex,
                myAnswer,
                answered: isChoice
                  ? Array.isArray(myAnswer)
                    ? myAnswer.length > 0
                    : !!myAnswer
                  : isBlank
                    ? myAnswer.some(v => v !== '')
                    : typeof myAnswer === 'string'
                      ? !!myAnswer.trim()
                      : !!myAnswer,
                showAnalysis: false,
                isFav: q.isFav || false,
              };
            });
          });
          this.sections = sections;
          if (this.mode === 'back' && !this.reviewedIds.includes(0)) {
            this.reviewedIds.push(0);
          }
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    hasChoiceUserAnswer(q) {
      if (q.type === 'MULTIPLECHOICE') return Array.isArray(q.myAnswer) && q.myAnswer.length > 0;
      return q.myAnswer !== '' && q.myAnswer != null;
    },
    isChoiceAnswerWrong(q) {
      if (!this.hasChoiceUserAnswer(q)) return false;
      if (q.type === 'MULTIPLECHOICE') {
        const user = [...q.myAnswer].sort().join('');
        const ans = String(q.answer || '')
          .split('')
          .filter(Boolean)
          .sort()
          .join('');
        return user !== ans;
      }
      return q.myAnswer !== q.answer;
    },
    flatIndex(si, qi) {
      let idx = 0;
      for (let i = 0; i < si; i++) idx += this.sections[i].questions.length;
      return idx + qi;
    },
    sectionTitle(section, si) {
      return _sectionTitle(section, si);
    },
    isSectionActive(si) {
      // 单题模式下，判断当前题目是否属于该 section
      if (this.viewMode !== 'single') return false;
      let start = 0;
      for (let i = 0; i < si; i++) start += this.sections[i].questions.length;
      const end = start + this.sections[si].questions.length;
      return this.singleIndex >= start && this.singleIndex < end;
    },
    getOptionClass(q, val) {
      if (this.mode === 'back') {
        if (q.type === 'MULTIPLECHOICE') {
          return { correct: q.answer && q.answer.includes(val) };
        }
        return { correct: val === q.answer };
      }
      if (!q.answered) return {};
      if (q.type === 'MULTIPLECHOICE') {
        return { selected: Array.isArray(q.myAnswer) && q.myAnswer.includes(val) };
      }
      return { selected: val === q.myAnswer };
    },
    selectOption(q, val) {
      if (this.mode === 'back') return;
      if (q.type === 'MULTIPLECHOICE') {
        let arr = Array.isArray(q.myAnswer) ? [...q.myAnswer] : [];
        const idx = arr.indexOf(val);
        if (idx === -1) arr.push(val); else arr.splice(idx, 1);
        arr.sort();
        this.$set(q, 'myAnswer', arr);
        this.$set(q, 'answered', arr.length > 0);
      } else {
        this.$set(q, 'myAnswer', val);
        this.$set(q, 'answered', true);
      }
      this.saveAnswer(q);
    },
    onSubjectiveInput(q) {
      this.$set(q, 'answered', !!q.myAnswer.trim());
    },
    onBlankInput(q) {
      this.$set(q, 'answered', q.myAnswer.some(v => v !== ''));
    },
    toggleFav(q) {
      const newVal = !q.isFav;
      this.$set(q, 'isFav', newVal);
      this.$http.post('/student/pc/freeStudy/toggleFav', {
        questionId: q.id,
        isFav: newVal,
        courseId: this.courseId,
      });
    },
    saveAnswer(q) {
      this.$http.post('/student/pc/freeStudy/saveAnswer', {
        paperId: this.paperId,
        questionId: q.id,
        answer: q.myAnswer,
      });
    },
    goQuestion(idx) {
      if (this.viewMode === 'single') {
        this.singleIndex = idx;
      } else {
        // 整卷模式：滚动到对应题目
        this.singleIndex = idx;
        this.$nextTick(() => {
          const ref = this.$refs['qItem_' + idx];
          const el = ref && (Array.isArray(ref) ? ref[0] : ref);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    },
    handleSubmit() {
      const unanswered = this.totalCount - this.answeredCount;
      const tip = unanswered > 0
        ? `还有 ${unanswered} 题未作答，确定提交试卷吗？提交后不可修改。`
        : '确定提交试卷吗？提交后不可修改。';
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post('/student/pc/freeStudy/submitPaper', { paperId: this.paperId }).then(() => {
          this.$message.success('提交成功');
          this.$router.replace({
            path: '/main/paperResult',
            query: {
              paperId: this.paperId,
              courseId: this.courseId,
            },
          });
        });
      }).catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.free-study-page { min-height: 639px; }
.content-wrap {
  width: 100%;
  overflow: hidden;
  .mianbao { font-size: 14px; }
}
.paper-header {
  background: $primary-light; border-radius: 10px; padding: 20px 24px; margin-bottom: 16px;
  border: 1px solid $primary-border; display: flex; justify-content: space-between; align-items: center;
  margin-top: 15px;
  .paper-title { font-size: 18px; font-weight: bold; color: #333; margin-bottom: 10px; }
  .paper-meta { font-size: 13px; color: #666; display: flex; gap: 30px; }
}
.mode-badge {
  display: inline-flex; align-items: center; gap: 6px; padding: 5px 14px;
  border-radius: 16px; font-size: 13px; font-weight: bold;
  border: 1px solid $primary-dark; background: $primary-light; color: $primary-dark;
  .dot { width: 8px; height: 8px; border-radius: 50%; background: $primary-dark; }
}
.toolbar {
  background: #fff; border-radius: 10px; padding: 12px 24px; margin-bottom: 16px;
  border: 1px solid #e3e3e3; display: flex; align-items: center; justify-content: space-between;
  .left { display: flex; align-items: center; gap: 16px; }
  .right { display: flex; align-items: center; gap: 12px; }
  .answer-progress { font-size: 13px; color: #999; }
}
.view-switch {
  display: flex; border: 1px solid #ddd; border-radius: 20px; overflow: hidden;
  .view-btn {
    padding: 6px 16px; font-size: 13px; cursor: pointer; transition: all .2s; color: #666; background: #fff;
    &.active { background: $primary-dark; color: #fff; border-color: $primary-dark; }
  }
}
.question-area { display: flex; gap: 16px; align-items: flex-start; }
.question-main { flex: 1; }
.question-card {
  background: #fff; border-radius: 10px; padding: 24px; margin-bottom: 16px; border: 1px solid #e3e3e3;
}
.q-section-title {
  font-size: 15px; font-weight: bold; color: #333; margin-bottom: 16px;
  padding-bottom: 10px; border-bottom: 1px solid #f2f2f2;
}
.q-item {
  margin-bottom: 24px; padding-bottom: 20px; border-bottom: 1px dashed #eee;
  &:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; }
}
.q-num {
  font-size: 14px; color: #333; font-weight: bold; margin-bottom: 10px; line-height: 1.6;
  display: flex; align-items: center; justify-content: space-between;
}
.questionTxt{
    flex: 1;
    margin: 0 10px;
  }
.q-options {
  list-style: none; padding: 0;
  li {
    padding: 8px 14px; margin-bottom: 6px; border-radius: 6px; border: 1px solid #e3e3e3;
    font-size: 14px; cursor: pointer; transition: all .15s; display: flex; align-items: center; gap: 8px;
    &:hover { border-color: $primary-dark; background: $primary-light-2; }
    &.selected { border-color: $primary-dark; background: $primary-light; color: $primary-dark; }
    &.correct { border-color: #67c23a; background: #f0f9eb; }
    &.wrong { border-color: #f56c6c; background: #fef0f0; }
    .radio {
      width: 16px; height: 16px; border-radius: 50%; border: 2px solid #ccc; flex-shrink: 0;
      display: flex; align-items: center; justify-content: center;
    }
    &.selected .radio {
      border-color: $primary-dark;
      &::after { content: ''; width: 8px; height: 8px; border-radius: 50%; background: $primary-dark; }
    }
    &.correct .radio {
      border-color: #67c23a; background: #67c23a;
      &::after { content: '\2713'; color: #fff; font-size: 10px; line-height: 1; }
    }
    &.wrong.your-choice .radio {
      border-color: #f56c6c;
      &::after { content: '\2717'; color: #f56c6c; font-size: 10px; line-height: 1; }
    }
  }
}
.analysis-box {
  background: #f9f9f9; border-radius: 8px; padding: 14px 18px; margin-top: 12px; border-left: 3px solid $primary-dark;
  .label { font-size: 13px; color: $primary-dark; font-weight: bold; margin-bottom: 6px; }
  .answer { font-size: 13px; color: #333; margin-bottom: 4px; }
  .detail { font-size: 13px; color: #666; line-height: 1.8; }
}
.analysis-btn {
  display: inline-block; padding: 4px 14px; border-radius: 14px; border: 1px solid $primary-dark;
  color: $primary-dark; font-size: 13px; cursor: pointer; margin-top: 8px; background: #fff;
  &:hover { background: $primary-light; }
}
.fav-btn {
  display: inline-flex; align-items: center; gap: 4px; padding: 4px 14px; border-radius: 14px;
  border: 1px solid #e3e3e3; color: #999; font-size: 13px; cursor: pointer; background: #fff;
  transition: all .2s; user-select: none; margin: 0; flex-shrink: 0;
  &:hover { border-color: $accent; color: $accent; background: #fff9f0; }
  &.active { border-color: $accent; color: $accent; background: #fff9f0; }
  .fav-icon { font-size: 14px; line-height: 1; &::before { content: '\2606'; } }
  &.active .fav-icon::before { content: '\2605'; }
}
.subjective-area {
  width: 100%; min-height: 100px; border: 1px solid #e3e3e3; border-radius: 6px;
  padding: 10px; font-size: 14px; resize: vertical; font-family: inherit;
  &:focus { outline: none; border-color: $primary-dark; }
}
.blank-inputs {
  display: flex; flex-direction: column; gap: 8px;
  .blank-input {
    width: 100%; height: 36px; border: 1px solid #e3e3e3; border-radius: 6px;
    padding: 0 10px; font-size: 14px; box-sizing: border-box;
    &:focus { outline: none; border-color: $primary-dark; }
  }
}
.answer-sheet { width: 240px; flex-shrink: 0; }

.back-mode {
  .q-options li {
    cursor: default; color: #ccc; background: #fafafa; border-color: #eee;
    &:hover { border-color: #eee; background: #fafafa; }
    &.correct { border-color: #c8e6c9; background: #f1f8e9; color: #999;
      .radio { border-color: #a5d6a7; background: #a5d6a7; }
    }
    .radio { border-color: #e0e0e0; }
  }
  .analysis-btn { display: none; }
}
.sheet-card {
  background: #fff; border-radius: 10px; padding: 16px; border: 1px solid #e3e3e3;
  position: fixed; top: 343px; width: 240px;z-index: 999;
  .sheet-title { font-size: 15px; font-weight: bold; color: #333; margin-bottom: 12px; text-align: center; }
}
.sheet-legend {
  display: flex; gap: 16px; font-size: 12px; color: #999; justify-content: center; margin-bottom: 12px;
  span { display: flex; align-items: center; gap: 4px; }
  .dot { width: 12px; height: 12px; border-radius: 3px; }
  .dot.c1 { background: $primary-light; border: 1px solid $primary-dark; }
  .dot.c2 { border: 1px solid #bbb; }
  .dot.c3 { background: $primary-dark; }
}
.sheet-grid {
  display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px;
  .num {
    width: 32px; height: 32px; border-radius: 6px; border: 1px solid #bbb;
    display: flex; align-items: center; justify-content: center; font-size: 13px; color: #666; cursor: pointer;
    &.done { background: $primary-light; color: $primary-dark; border-color: $primary-dark; }
    &.current { background: $primary-dark; color: #fff; border-color: $primary-dark; }
  }
}
.submit-btn {
  display: block; width: 100%; padding: 10px; border-radius: 20px; background: $primary-dark;
  color: #fff; font-size: 14px; border: none; cursor: pointer; text-align: center;
  &:hover { background: $primary; }
}
.single-nav {
  display: flex; align-items: center; justify-content: space-between; padding: 16px 0;
  .nav-btn {
    padding: 8px 28px; border-radius: 20px; font-size: 14px; cursor: pointer;
    border: 1px solid $primary-dark; color: $primary-dark; background: #fff; transition: all .2s;
    &:hover { background: $primary-light; }
    &.primary { background: $primary-dark; color: #fff; &:hover { background: $primary; } }
    &:disabled { border-color: #ccc; color: #ccc; background: #f8f8f8; cursor: not-allowed; }
  }
  .progress { font-size: 14px; color: #666;line-height: 24px;height: 24px; b { color: $primary-dark; } }
}
</style>
